import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgForward = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.8079 10.9142V13.4708C10.8079 14.1933 11.6654 14.5733 12.2012 14.0883L17.2262 9.53333C17.5996 9.195 17.5896 8.60583 17.2054 8.28083L12.1804 4.01581C11.6387 3.55581 10.8079 3.94081 10.8079 4.65081V6.68165C6.2554 6.68165 2.47457 9.49166 2.47457 14.1667V15.1075C4.01374 12.0375 7.21374 10.9142 10.8079 10.9142Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgForward;
